import type { SiteContent } from '@/types/site-content';

import { api } from './api';

export type PricingSettings = {
  marginPercent: number;
  mamMaxPercent: number;
  /** Not logged-in customers earn MAM (buyer email matched to an A2A account after payment). */
  mamGuestEarnEnabled: boolean;
};

export const siteContentService = {
  getPublic: (): Promise<SiteContent> => {
    return api.get<SiteContent>('/api/site-content');
  },

  getPublicPricingSettings: (): Promise<PricingSettings> => {
    return api.get<PricingSettings>('/api/site-content/pricing-settings');
  },

  getAdmin: (): Promise<SiteContent> => {
    return api.get<SiteContent>('/api/admin/site-content');
  },

  patchAdmin: (payload: SiteContent): Promise<SiteContent> => {
    return api.patch<SiteContent>('/api/admin/site-content', payload);
  },

  getAdminPricingSettings: (): Promise<PricingSettings> => {
    return api.get<PricingSettings>('/api/admin/site-content/pricing-settings');
  },

  patchAdminPricingSettings: (payload: PricingSettings): Promise<PricingSettings> => {
    return api.patch<PricingSettings>('/api/admin/site-content/pricing-settings', payload);
  },

  /** A2A accounts with the fixed 1 EUR order price while logged in at checkout (admin only). */
  getAdminFixedPriceEmails: async (): Promise<string[]> => {
    const response = await api.get<{ emails: string[] }>(
      '/api/admin/site-content/pricing-settings/fixed-price-emails',
    );
    return response.emails;
  },

  patchAdminFixedPriceEmails: async (emails: string[]): Promise<string[]> => {
    const response = await api.patch<{ emails: string[] }>(
      '/api/admin/site-content/pricing-settings/fixed-price-emails',
      { emails },
    );
    return response.emails;
  },
};
